<div class="section-tooltip"
     *ngIf="tooltip.visible"
     [style.left.px]="tooltip.x"
     [style.top.px]="tooltip.y"
     (mouseenter)="onTooltipEnter()"
     (mouseleave)="onTooltipLeave()">
  <div *ngIf="tooltip.loading" class="tooltip-loading">
    <div class="tooltip-spinner"></div>
    Loading preview...
  </div>
  <div *ngIf="!tooltip.loading">
    <div *ngIf="tooltip.title" class="tooltip-title">{{ tooltip.title }}</div>
    <div class="tooltip-content" [innerHTML]="tooltip.content"></div>
    <div *ngIf="tooltip.references" class="tooltip-references">
      <div class="tooltip-references-header">References</div>
      <div [innerHTML]="tooltip.references"></div>
    </div>
  </div>
</div>
